import { InferResponseDataType } from '@frontend/api-client-user/client/types';
import {
	createQueryKeyStore,
	inferQueryKeyStore,
} from '@lukemorales/query-key-factory';
import {
	campaignDetailFN,
	campaignListFN,
	roomGroupByIdFn,
	roomGroupsFn,
	roomGroupsThresholdsFn,
	roomGroupUsageFN,
	roomTypesFn,
	sectionMapFN,
	sectionsFn,
	sectionThresholdsFN,
	usageFN,
} from '@/server/get';
import { CampaignStatus } from '@frontend/api-client-user/types';
import { shiftEmployeesFn } from '@/server/shift-employees';

export type SectionMapResponseType = InferResponseDataType<
	'/v1/sections/{sectionId}/map',
	'get'
>;

export type QueryKeys = inferQueryKeyStore<typeof queries>;

export const queries = createQueryKeyStore({
	'room-groups': {
		list: {
			queryKey: null,
			queryFn: () => roomGroupsFn(),
		},
		detail: (roomGroupId) => ({
			queryKey: [roomGroupId],
			queryFn: () =>
				roomGroupId ? roomGroupByIdFn({ data: { roomGroupId } }) : undefined,
		}),
		thresholds: {
			queryKey: null,
			queryFn: () => roomGroupsThresholdsFn(),
		},
	},
	'room-groups-usage': {
		list: (start: Date | string, end: Date | string) => ({
			queryKey: [start, end],
			queryFn: () => roomGroupUsageFN({ data: { start, end } }),
		}),
	},
	'room-types': {
		list: (isDemo = false) => ({
			queryKey: [isDemo],
			queryFn: () => roomTypesFn(),
		}),
	},
	sections: {
		list: (isDemo = false) => ({
			queryKey: [isDemo],
			queryFn: () => sectionsFn(),
		}),
		map: (sectionId?: string) => ({
			queryKey: [sectionId],
			retry: false,
			enabled: false,
			queryFn: () => sectionMapFN({ data: { sectionId } }),
		}),
		thresholds: (sectionId: string[]) => ({
			queryKey: [sectionId],
			queryFn: () => sectionThresholdsFN({ data: { sectionId } }),
		}),
	},
	campaigns: {
		list: (status?: CampaignStatus) => ({
			queryKey: [status],
			queryFn: () => campaignListFN({ data: { status } }),
		}),
		detail: (campaignId: string) => ({
			queryKey: [campaignId],
			queryFn: () => campaignDetailFN({ data: { campaignId } }),
		}),
	},
	usage: {
		list: (sectionId: string, start: Date | string, end: Date | string) => ({
			queryKey: [sectionId, start, end],
			queryFn: () => usageFN({ data: { sectionId, start, end } }),
		}),
	},
	generate: {
		'get-shift-employees': {
			queryKey: null,
			queryFn: () => shiftEmployeesFn({}),
		},
	},
});
